import React from "react";
import Logo from "../../../../../assets/home/logo.svg";

const formatTime = (seconds = 0) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}m ${secs}s`;
};

const ResultHeader = ({ exam, overall }) => {
  return (
    <div className="w-full bg-[#88C0FF] py-5">
      <div className="max-w-[1400px] mx-auto px-3 py-4 grid grid-cols-1 lg:grid-cols-3 items-center">
        {/* Left Logo */}
        <div className="flex justify-start">
          <img
            src={Logo}
            alt="BaapBola Logo"
            className="object-contain w-[110px] sm:w-[130px] md:w-[150px] lg:w-[170px]"
          />
        </div>

        {/* Center Content */}
        <div className="text-center mt-4 lg:mt-0">
          <h2 className="font-[600] text-[#333] text-[18px] md:text-[22px]">
            Exam Results & Detailed Analysis
          </h2>

          <p className="font-[500] text-[14px] md:text-[16px] text-[#333] mt-1">
            {exam?.name || "Test Result"}
          </p>

          <div className="flex gap-8 justify-center mt-4">
            <div>
              <p className="text-[#333] font-[600] text-[18px] md:text-[22px]">
                {overall?.score}/{overall?.totalQuestions}
              </p>
              <p className="text-[12px] text-[#333]">Total Score</p>
            </div>

            <div>
              <p className="text-[#333] font-[600] text-[18px] md:text-[22px]">
                {formatTime(overall?.timeTakenSeconds)}
              </p>
              <p className="text-[12px] text-[#333]">Time Taken</p>
            </div>
          </div>
        </div>

        {/* Right spacer */}
        <div />
      </div>
    </div>
  );
};


export default ResultHeader;
